//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.8.0 (NJsonSchema v11.0.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import followIfLoginRedirect from './components/api-authorization/followIfLoginRedirect';

export class AdminClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getUsers(): Promise<UserWithRolesDto[]> {
        let url_ = this.baseUrl + "/api/Admin/users";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUsers(_response);
        });
    }

    protected processGetUsers(response: Response): Promise<UserWithRolesDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserWithRolesDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserWithRolesDto[]>(null as any);
    }

    getRoles(): Promise<string[]> {
        let url_ = this.baseUrl + "/api/Admin/roles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRoles(_response);
        });
    }

    protected processGetRoles(response: Response): Promise<string[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    getUserById(id: string): Promise<ApplicationUser> {
        let url_ = this.baseUrl + "/api/Admin/user/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUserById(_response);
        });
    }

    protected processGetUserById(response: Response): Promise<ApplicationUser> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicationUser.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApplicationUser>(null as any);
    }

    deleteUser(id: string): Promise<void> {
        let url_ = this.baseUrl + "/api/Admin/user/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteUser(_response);
        });
    }

    protected processDeleteUser(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getUserRolesByUserId(id: string): Promise<string[]> {
        let url_ = this.baseUrl + "/api/Admin/user/roles/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUserRolesByUserId(_response);
        });
    }

    protected processGetUserRolesByUserId(response: Response): Promise<string[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    updateUserRoles(id: string, roles: string[]): Promise<string[]> {
        let url_ = this.baseUrl + "/api/Admin/user/roles/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(roles);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateUserRoles(_response);
        });
    }

    protected processUpdateUserRoles(response: Response): Promise<string[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    createUser(createUserDto: CreateUserDto): Promise<UserUpdateResponseDto> {
        let url_ = this.baseUrl + "/api/Admin/user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createUserDto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateUser(_response);
        });
    }

    protected processCreateUser(response: Response): Promise<UserUpdateResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserUpdateResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserUpdateResponseDto>(null as any);
    }

    updateUser(id: string, userDto: UpdateUserDto): Promise<UserUpdateResponseDto> {
        let url_ = this.baseUrl + "/api/Admin/user?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userDto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateUser(_response);
        });
    }

    protected processUpdateUser(response: Response): Promise<UserUpdateResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserUpdateResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserUpdateResponseDto>(null as any);
    }

    resetPassword(id: string, newPassword: string): Promise<void> {
        let url_ = this.baseUrl + "/api/Admin/user/{id}/reset-password?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (newPassword === undefined || newPassword === null)
            throw new Error("The parameter 'newPassword' must be defined and cannot be null.");
        else
            url_ += "newPassword=" + encodeURIComponent("" + newPassword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processResetPassword(_response);
        });
    }

    protected processResetPassword(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    createDealer(dto: CreateDealerDto): Promise<UserUpdateResponseDto> {
        let url_ = this.baseUrl + "/api/Admin/dealer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateDealer(_response);
        });
    }

    protected processCreateDealer(response: Response): Promise<UserUpdateResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserUpdateResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserUpdateResponseDto>(null as any);
    }

    getDealers(): Promise<DealerDto[]> {
        let url_ = this.baseUrl + "/api/Admin/dealers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDealers(_response);
        });
    }

    protected processGetDealers(response: Response): Promise<DealerDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DealerDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DealerDto[]>(null as any);
    }

    updateDealer(id: number, dealerDto: DealerDto): Promise<void> {
        let url_ = this.baseUrl + "/api/Admin/dealer/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dealerDto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateDealer(_response);
        });
    }

    protected processUpdateDealer(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getDealerLogo(dealerId: number): Promise<DealerLogoInfoDto> {
        let url_ = this.baseUrl + "/api/Admin/dealers/{dealerId}/logo";
        if (dealerId === undefined || dealerId === null)
            throw new Error("The parameter 'dealerId' must be defined.");
        url_ = url_.replace("{dealerId}", encodeURIComponent("" + dealerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDealerLogo(_response);
        });
    }

    protected processGetDealerLogo(response: Response): Promise<DealerLogoInfoDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DealerLogoInfoDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DealerLogoInfoDto>(null as any);
    }

    uploadDealerLogo(dealerId: number, file: FileParameter | null | undefined): Promise<DealerLogoInfoDto> {
        let url_ = this.baseUrl + "/api/Admin/dealers/{dealerId}/logo";
        if (dealerId === undefined || dealerId === null)
            throw new Error("The parameter 'dealerId' must be defined.");
        url_ = url_.replace("{dealerId}", encodeURIComponent("" + dealerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadDealerLogo(_response);
        });
    }

    protected processUploadDealerLogo(response: Response): Promise<DealerLogoInfoDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = DealerLogoInfoDto.fromJS(resultData201);
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DealerLogoInfoDto>(null as any);
    }

    deleteDealerLogo(dealerId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Admin/dealers/{dealerId}/logo";
        if (dealerId === undefined || dealerId === null)
            throw new Error("The parameter 'dealerId' must be defined.");
        url_ = url_.replace("{dealerId}", encodeURIComponent("" + dealerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteDealerLogo(_response);
        });
    }

    protected processDeleteDealerLogo(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class AttachmentsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    uploadImage(id: number, type: string, name: string, description: string, file: FileParameter | null | undefined): Promise<AttachmentDto> {
        let url_ = this.baseUrl + "/api/Attachments?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined and cannot be null.");
        else
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined and cannot be null.");
        else
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (description === undefined || description === null)
            throw new Error("The parameter 'description' must be defined and cannot be null.");
        else
            url_ += "description=" + encodeURIComponent("" + description) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadImage(_response);
        });
    }

    protected processUploadImage(response: Response): Promise<AttachmentDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AttachmentDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AttachmentDto>(null as any);
    }

    deleteVehicleImage(id: number): Promise<AttachmentDto> {
        let url_ = this.baseUrl + "/api/Attachments/vehicle/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteVehicleImage(_response);
        });
    }

    protected processDeleteVehicleImage(response: Response): Promise<AttachmentDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AttachmentDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AttachmentDto>(null as any);
    }

    deleteInspectionRecordImage(id: number): Promise<AttachmentDto> {
        let url_ = this.baseUrl + "/api/Attachments/inspection-record/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteInspectionRecordImage(_response);
        });
    }

    protected processDeleteInspectionRecordImage(response: Response): Promise<AttachmentDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AttachmentDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AttachmentDto>(null as any);
    }
}

export class CategorysClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getCategoryList(dealerId: number): Promise<CategoryDto[]> {
        let url_ = this.baseUrl + "/api/Categorys?";
        if (dealerId === undefined || dealerId === null)
            throw new Error("The parameter 'dealerId' must be defined and cannot be null.");
        else
            url_ += "DealerId=" + encodeURIComponent("" + dealerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCategoryList(_response);
        });
    }

    protected processGetCategoryList(response: Response): Promise<CategoryDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CategoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CategoryDto[]>(null as any);
    }
}

export class CurrentUserClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getCurrentUser(): Promise<UserDto> {
        let url_ = this.baseUrl + "/api/CurrentUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCurrentUser(_response);
        });
    }

    protected processGetCurrentUser(response: Response): Promise<UserDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDto>(null as any);
    }
}

export class DealersClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getDealerInfo(dealerId: number | null | undefined): Promise<DealerLogoDto> {
        let url_ = this.baseUrl + "/api/Dealers?";
        if (dealerId !== undefined && dealerId !== null)
            url_ += "DealerId=" + encodeURIComponent("" + dealerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDealerInfo(_response);
        });
    }

    protected processGetDealerInfo(response: Response): Promise<DealerLogoDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DealerLogoDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DealerLogoDto>(null as any);
    }
}

export class InspectionItemsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getInspectionItemList(dealerId: number, searchTerm: string | null | undefined): Promise<InspectionItemDto[]> {
        let url_ = this.baseUrl + "/api/InspectionItems?";
        if (dealerId === undefined || dealerId === null)
            throw new Error("The parameter 'dealerId' must be defined and cannot be null.");
        else
            url_ += "DealerId=" + encodeURIComponent("" + dealerId) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetInspectionItemList(_response);
        });
    }

    protected processGetInspectionItemList(response: Response): Promise<InspectionItemDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InspectionItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InspectionItemDto[]>(null as any);
    }

    createInspectionItem(command: CreateInspectionItemCommand): Promise<InspectionItemDto> {
        let url_ = this.baseUrl + "/api/InspectionItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateInspectionItem(_response);
        });
    }

    protected processCreateInspectionItem(response: Response): Promise<InspectionItemDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InspectionItemDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InspectionItemDto>(null as any);
    }

    getInspectionItemById(id: number): Promise<InspectionItemDto> {
        let url_ = this.baseUrl + "/api/InspectionItems/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetInspectionItemById(_response);
        });
    }

    protected processGetInspectionItemById(response: Response): Promise<InspectionItemDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InspectionItemDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InspectionItemDto>(null as any);
    }

    updateInspectionItem(id: number, command: UpdateInspectionItemCommand): Promise<InspectionItemDto> {
        let url_ = this.baseUrl + "/api/InspectionItems/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateInspectionItem(_response);
        });
    }

    protected processUpdateInspectionItem(response: Response): Promise<InspectionItemDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InspectionItemDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InspectionItemDto>(null as any);
    }

    deleteInspectionItem(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/InspectionItems/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteInspectionItem(_response);
        });
    }

    protected processDeleteInspectionItem(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class InspectionsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getInspectionById(id: number): Promise<InspectionDto> {
        let url_ = this.baseUrl + "/api/Inspections/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetInspectionById(_response);
        });
    }

    protected processGetInspectionById(response: Response): Promise<InspectionDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InspectionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InspectionDto>(null as any);
    }

    updateInspection(id: number, command: UpdateInspectionCommand): Promise<InspectionDto> {
        let url_ = this.baseUrl + "/api/Inspections/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateInspection(_response);
        });
    }

    protected processUpdateInspection(response: Response): Promise<InspectionDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InspectionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InspectionDto>(null as any);
    }

    deleteInspection(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Inspections/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteInspection(_response);
        });
    }

    protected processDeleteInspection(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getInspectionItemPhotosById(inspectionId: number, inspectionItemId: number): Promise<PhotoResponseDto[]> {
        let url_ = this.baseUrl + "/api/Inspections/{inspectionId}/records/{inspectionItemId}/photos";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        if (inspectionItemId === undefined || inspectionItemId === null)
            throw new Error("The parameter 'inspectionItemId' must be defined.");
        url_ = url_.replace("{inspectionItemId}", encodeURIComponent("" + inspectionItemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetInspectionItemPhotosById(_response);
        });
    }

    protected processGetInspectionItemPhotosById(response: Response): Promise<PhotoResponseDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PhotoResponseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PhotoResponseDto[]>(null as any);
    }

    getInspectionItemVideosById(inspectionId: number, inspectionItemId: number): Promise<PhotoResponseDto[]> {
        let url_ = this.baseUrl + "/api/Inspections/{inspectionId}/records/{inspectionItemId}/videos";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        if (inspectionItemId === undefined || inspectionItemId === null)
            throw new Error("The parameter 'inspectionItemId' must be defined.");
        url_ = url_.replace("{inspectionItemId}", encodeURIComponent("" + inspectionItemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetInspectionItemVideosById(_response);
        });
    }

    protected processGetInspectionItemVideosById(response: Response): Promise<PhotoResponseDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PhotoResponseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PhotoResponseDto[]>(null as any);
    }

    getInspectionPhotos(inspectionId: number, itemIds: number[] | null | undefined, since: Date | null | undefined, page: number | null | undefined, pageSize: number | null | undefined): Promise<PhotoResponseDto[]> {
        let url_ = this.baseUrl + "/api/Inspections/{inspectionId}/photos?";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        if (itemIds !== undefined && itemIds !== null)
            itemIds && itemIds.forEach(item => { url_ += "itemIds=" + encodeURIComponent("" + item) + "&"; });
        if (since !== undefined && since !== null)
            url_ += "since=" + encodeURIComponent(since ? "" + since.toISOString() : "") + "&";
        if (page !== undefined && page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetInspectionPhotos(_response);
        });
    }

    protected processGetInspectionPhotos(response: Response): Promise<PhotoResponseDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PhotoResponseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PhotoResponseDto[]>(null as any);
    }

    uploadInspectionPhoto(inspectionId: number, inspectionItemId: number, file: FileParameter | null | undefined): Promise<PhotoResponseDto> {
        let url_ = this.baseUrl + "/api/Inspections/{inspectionId}/photos?";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        if (inspectionItemId === undefined || inspectionItemId === null)
            throw new Error("The parameter 'inspectionItemId' must be defined and cannot be null.");
        else
            url_ += "inspectionItemId=" + encodeURIComponent("" + inspectionItemId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadInspectionPhoto(_response);
        });
    }

    protected processUploadInspectionPhoto(response: Response): Promise<PhotoResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = PhotoResponseDto.fromJS(resultData201);
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PhotoResponseDto>(null as any);
    }

    getInspectionVideos(inspectionId: number, itemIds: number[] | null | undefined, since: Date | null | undefined, page: number | null | undefined, pageSize: number | null | undefined): Promise<PhotoResponseDto[]> {
        let url_ = this.baseUrl + "/api/Inspections/{inspectionId}/videos?";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        if (itemIds !== undefined && itemIds !== null)
            itemIds && itemIds.forEach(item => { url_ += "itemIds=" + encodeURIComponent("" + item) + "&"; });
        if (since !== undefined && since !== null)
            url_ += "since=" + encodeURIComponent(since ? "" + since.toISOString() : "") + "&";
        if (page !== undefined && page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetInspectionVideos(_response);
        });
    }

    protected processGetInspectionVideos(response: Response): Promise<PhotoResponseDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PhotoResponseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PhotoResponseDto[]>(null as any);
    }

    uploadInspectionVideo(inspectionId: number, inspectionItemId: number, file: FileParameter | null | undefined): Promise<PhotoResponseDto> {
        let url_ = this.baseUrl + "/api/Inspections/{inspectionId}/videos?";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        if (inspectionItemId === undefined || inspectionItemId === null)
            throw new Error("The parameter 'inspectionItemId' must be defined and cannot be null.");
        else
            url_ += "inspectionItemId=" + encodeURIComponent("" + inspectionItemId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadInspectionVideo(_response);
        });
    }

    protected processUploadInspectionVideo(response: Response): Promise<PhotoResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = PhotoResponseDto.fromJS(resultData201);
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PhotoResponseDto>(null as any);
    }

    countScan(inspectionId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Inspections/{inspectionId}/count-scan";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCountScan(_response);
        });
    }

    protected processCountScan(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getInspectionList(dealerId: number, pageNumber: number, pageSize: number, searchTerm: string | null | undefined, sortColumn: string | null | undefined, sortDirection: string | null | undefined, filterStatus: number | null | undefined): Promise<PaginatedListOfInspectionDto> {
        let url_ = this.baseUrl + "/api/Inspections?";
        if (dealerId === undefined || dealerId === null)
            throw new Error("The parameter 'dealerId' must be defined and cannot be null.");
        else
            url_ += "DealerId=" + encodeURIComponent("" + dealerId) + "&";
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (filterStatus !== undefined && filterStatus !== null)
            url_ += "FilterStatus=" + encodeURIComponent("" + filterStatus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetInspectionList(_response);
        });
    }

    protected processGetInspectionList(response: Response): Promise<PaginatedListOfInspectionDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfInspectionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfInspectionDto>(null as any);
    }

    createInspection(command: CreateInspectionCommand): Promise<InspectionDto> {
        let url_ = this.baseUrl + "/api/Inspections";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateInspection(_response);
        });
    }

    protected processCreateInspection(response: Response): Promise<InspectionDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InspectionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InspectionDto>(null as any);
    }

    deleteInspectionPhoto(inspectionId: number, photoId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Inspections/{inspectionId}/photos/{photoId}";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        if (photoId === undefined || photoId === null)
            throw new Error("The parameter 'photoId' must be defined.");
        url_ = url_.replace("{photoId}", encodeURIComponent("" + photoId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteInspectionPhoto(_response);
        });
    }

    protected processDeleteInspectionPhoto(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    uploadVehicleHistoryReport(inspectionId: number, file: FileParameter | null | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/Inspections/{inspectionId}/vehicle-history-report";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadVehicleHistoryReport(_response);
        });
    }

    protected processUploadVehicleHistoryReport(response: Response): Promise<any> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : <any>null;
    
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(null as any);
    }

    deleteVehicleHistoryReport(inspectionId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Inspections/{inspectionId}/vehicle-history-report";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteVehicleHistoryReport(_response);
        });
    }

    protected processDeleteVehicleHistoryReport(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    uploadVehicleServiceRecord(inspectionId: number, file: FileParameter | null | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/Inspections/{inspectionId}/vehicle-service-record";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadVehicleServiceRecord(_response);
        });
    }

    protected processUploadVehicleServiceRecord(response: Response): Promise<any> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : <any>null;
    
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(null as any);
    }

    deleteVehicleServiceRecord(inspectionId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Inspections/{inspectionId}/vehicle-service-record";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteVehicleServiceRecord(_response);
        });
    }

    protected processDeleteVehicleServiceRecord(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    resetScanCount(inspectionId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Inspections/{inspectionId}/reset-scan-count";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processResetScanCount(_response);
        });
    }

    protected processResetScanCount(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deleteInspectionVideo(inspectionId: number, videoId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Inspections/{inspectionId}/videos/{videoId}";
        if (inspectionId === undefined || inspectionId === null)
            throw new Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        if (videoId === undefined || videoId === null)
            throw new Error("The parameter 'videoId' must be defined.");
        url_ = url_.replace("{videoId}", encodeURIComponent("" + videoId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteInspectionVideo(_response);
        });
    }

    protected processDeleteInspectionVideo(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class LeadsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    createLead(dto: LeadDto): Promise<LeadDto> {
        let url_ = this.baseUrl + "/api/Leads";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateLead(_response);
        });
    }

    protected processCreateLead(response: Response): Promise<LeadDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LeadDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LeadDto>(null as any);
    }

    getLeads(dealerId: number): Promise<LeadDto[]> {
        let url_ = this.baseUrl + "/api/Leads/{dealerId}";
        if (dealerId === undefined || dealerId === null)
            throw new Error("The parameter 'dealerId' must be defined.");
        url_ = url_.replace("{dealerId}", encodeURIComponent("" + dealerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLeads(_response);
        });
    }

    protected processGetLeads(response: Response): Promise<LeadDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LeadDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LeadDto[]>(null as any);
    }

    updateLead(id: number, dto: LeadDto): Promise<LeadDto> {
        let url_ = this.baseUrl + "/api/Leads/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateLead(_response);
        });
    }

    protected processUpdateLead(response: Response): Promise<LeadDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LeadDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LeadDto>(null as any);
    }
}

export class SearchClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    globalSearch(searchString: string | null): Promise<GlobalSearchDto> {
        let url_ = this.baseUrl + "/api/Search/{searchString}";
        if (searchString === undefined || searchString === null)
            throw new Error("The parameter 'searchString' must be defined.");
        url_ = url_.replace("{searchString}", encodeURIComponent("" + searchString));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGlobalSearch(_response);
        });
    }

    protected processGlobalSearch(response: Response): Promise<GlobalSearchDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GlobalSearchDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GlobalSearchDto>(null as any);
    }
}

export class UsersClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getUsersInRole(roleName: string | null | undefined): Promise<UserDto[]> {
        let url_ = this.baseUrl + "/api/Users?";
        if (roleName !== undefined && roleName !== null)
            url_ += "RoleName=" + encodeURIComponent("" + roleName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUsersInRole(_response);
        });
    }

    protected processGetUsersInRole(response: Response): Promise<UserDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDto[]>(null as any);
    }
}

export class VehiclesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getVehicleById(id: number): Promise<VehicleDto> {
        let url_ = this.baseUrl + "/api/Vehicles/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetVehicleById(_response);
        });
    }

    protected processGetVehicleById(response: Response): Promise<VehicleDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VehicleDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VehicleDto>(null as any);
    }

    updateVehicle(id: number, command: UpdateVehicleCommand): Promise<VehicleDto> {
        let url_ = this.baseUrl + "/api/Vehicles/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateVehicle(_response);
        });
    }

    protected processUpdateVehicle(response: Response): Promise<VehicleDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VehicleDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VehicleDto>(null as any);
    }

    deleteVehicle(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Vehicles/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteVehicle(_response);
        });
    }

    protected processDeleteVehicle(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    decodeVin(vin: string, modelYear: number | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Vehicles/decode-vin/{vin}?";
        if (vin === undefined || vin === null)
            throw new Error("The parameter 'vin' must be defined.");
        url_ = url_.replace("{vin}", encodeURIComponent("" + vin));
        if (modelYear !== undefined && modelYear !== null)
            url_ += "modelYear=" + encodeURIComponent("" + modelYear) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDecodeVin(_response);
        });
    }

    protected processDecodeVin(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    decodeVinSummary(vin: string, modelYear: number | null | undefined): Promise<VinSummaryDto> {
        let url_ = this.baseUrl + "/api/Vehicles/decode-vin/{vin}/summary?";
        if (vin === undefined || vin === null)
            throw new Error("The parameter 'vin' must be defined.");
        url_ = url_.replace("{vin}", encodeURIComponent("" + vin));
        if (modelYear !== undefined && modelYear !== null)
            url_ += "modelYear=" + encodeURIComponent("" + modelYear) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDecodeVinSummary(_response);
        });
    }

    protected processDecodeVinSummary(response: Response): Promise<VinSummaryDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VinSummaryDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VinSummaryDto>(null as any);
    }

    getVehicleList(dealerId: number, pageNumber: number, pageSize: number, searchTerm: string | null | undefined, sortColumn: string | null | undefined, sortDirection: string | null | undefined, filterMakeId: number | null | undefined, filterModelId: number | null | undefined, filterYear: string | null | undefined, filterStatus: number | null | undefined): Promise<PaginatedListOfVehicleDto> {
        let url_ = this.baseUrl + "/api/Vehicles?";
        if (dealerId === undefined || dealerId === null)
            throw new Error("The parameter 'dealerId' must be defined and cannot be null.");
        else
            url_ += "DealerId=" + encodeURIComponent("" + dealerId) + "&";
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (filterMakeId !== undefined && filterMakeId !== null)
            url_ += "FilterMakeId=" + encodeURIComponent("" + filterMakeId) + "&";
        if (filterModelId !== undefined && filterModelId !== null)
            url_ += "FilterModelId=" + encodeURIComponent("" + filterModelId) + "&";
        if (filterYear !== undefined && filterYear !== null)
            url_ += "FilterYear=" + encodeURIComponent("" + filterYear) + "&";
        if (filterStatus !== undefined && filterStatus !== null)
            url_ += "FilterStatus=" + encodeURIComponent("" + filterStatus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetVehicleList(_response);
        });
    }

    protected processGetVehicleList(response: Response): Promise<PaginatedListOfVehicleDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfVehicleDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfVehicleDto>(null as any);
    }

    createVehicle(command: CreateVehicleCommand): Promise<VehicleDto> {
        let url_ = this.baseUrl + "/api/Vehicles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateVehicle(_response);
        });
    }

    protected processCreateVehicle(response: Response): Promise<VehicleDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VehicleDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VehicleDto>(null as any);
    }

    getMakes(searchTerm: string | null | undefined): Promise<IdLabelDto[]> {
        let url_ = this.baseUrl + "/api/Vehicles/makes?";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMakes(_response);
        });
    }

    protected processGetMakes(response: Response): Promise<IdLabelDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IdLabelDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IdLabelDto[]>(null as any);
    }

    getModelsByMake(make: number, searchTerm: string | null | undefined): Promise<IdLabelDto[]> {
        let url_ = this.baseUrl + "/api/Vehicles/models-by-make/{make}?";
        if (make === undefined || make === null)
            throw new Error("The parameter 'make' must be defined.");
        url_ = url_.replace("{make}", encodeURIComponent("" + make));
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetModelsByMake(_response);
        });
    }

    protected processGetModelsByMake(response: Response): Promise<IdLabelDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IdLabelDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IdLabelDto[]>(null as any);
    }
}

export class BillingClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    billing_StartCheckout(dto: StartCheckoutDto): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Billing/checkout-session";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processBilling_StartCheckout(_response);
        });
    }

    protected processBilling_StartCheckout(response: Response): Promise<FileResponse> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    billing_CreatePortal(dto: PortalRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Billing/portal-session";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processBilling_CreatePortal(_response);
        });
    }

    protected processBilling_CreatePortal(response: Response): Promise<FileResponse> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    billing_Webhook(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Billing/webhook";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processBilling_Webhook(_response);
        });
    }

    protected processBilling_Webhook(response: Response): Promise<FileResponse> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    billing_GetBillingStatus(dealerId: number | null | undefined): Promise<BillingStatusResponse> {
        let url_ = this.baseUrl + "/api/Billing/status?";
        if (dealerId !== undefined && dealerId !== null)
            url_ += "dealerId=" + encodeURIComponent("" + dealerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processBilling_GetBillingStatus(_response);
        });
    }

    protected processBilling_GetBillingStatus(response: Response): Promise<BillingStatusResponse> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BillingStatusResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BillingStatusResponse>(null as any);
    }
}

export class UserWithRolesDto implements IUserWithRolesDto {
    id?: string | undefined;
    userName?: string | undefined;
    email?: string | undefined;
    roles?: string[] | undefined;

    constructor(data?: IUserWithRolesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.email = _data["email"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
        }
    }

    static fromJS(data: any): UserWithRolesDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserWithRolesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["email"] = this.email;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        return data;
    }
}

export interface IUserWithRolesDto {
    id?: string | undefined;
    userName?: string | undefined;
    email?: string | undefined;
    roles?: string[] | undefined;
}

export class IdentityUserOfString implements IIdentityUserOfString {
    id?: string | undefined;
    userName?: string | undefined;
    normalizedUserName?: string | undefined;
    email?: string | undefined;
    normalizedEmail?: string | undefined;
    emailConfirmed?: boolean;
    passwordHash?: string | undefined;
    securityStamp?: string | undefined;
    concurrencyStamp?: string | undefined;
    phoneNumber?: string | undefined;
    phoneNumberConfirmed?: boolean;
    twoFactorEnabled?: boolean;
    lockoutEnd?: Date | undefined;
    lockoutEnabled?: boolean;
    accessFailedCount?: number;

    constructor(data?: IIdentityUserOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.normalizedUserName = _data["normalizedUserName"];
            this.email = _data["email"];
            this.normalizedEmail = _data["normalizedEmail"];
            this.emailConfirmed = _data["emailConfirmed"];
            this.passwordHash = _data["passwordHash"];
            this.securityStamp = _data["securityStamp"];
            this.concurrencyStamp = _data["concurrencyStamp"];
            this.phoneNumber = _data["phoneNumber"];
            this.phoneNumberConfirmed = _data["phoneNumberConfirmed"];
            this.twoFactorEnabled = _data["twoFactorEnabled"];
            this.lockoutEnd = _data["lockoutEnd"] ? new Date(_data["lockoutEnd"].toString()) : <any>undefined;
            this.lockoutEnabled = _data["lockoutEnabled"];
            this.accessFailedCount = _data["accessFailedCount"];
        }
    }

    static fromJS(data: any): IdentityUserOfString {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityUserOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["normalizedUserName"] = this.normalizedUserName;
        data["email"] = this.email;
        data["normalizedEmail"] = this.normalizedEmail;
        data["emailConfirmed"] = this.emailConfirmed;
        data["passwordHash"] = this.passwordHash;
        data["securityStamp"] = this.securityStamp;
        data["concurrencyStamp"] = this.concurrencyStamp;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneNumberConfirmed"] = this.phoneNumberConfirmed;
        data["twoFactorEnabled"] = this.twoFactorEnabled;
        data["lockoutEnd"] = this.lockoutEnd ? this.lockoutEnd.toISOString() : <any>undefined;
        data["lockoutEnabled"] = this.lockoutEnabled;
        data["accessFailedCount"] = this.accessFailedCount;
        return data;
    }
}

export interface IIdentityUserOfString {
    id?: string | undefined;
    userName?: string | undefined;
    normalizedUserName?: string | undefined;
    email?: string | undefined;
    normalizedEmail?: string | undefined;
    emailConfirmed?: boolean;
    passwordHash?: string | undefined;
    securityStamp?: string | undefined;
    concurrencyStamp?: string | undefined;
    phoneNumber?: string | undefined;
    phoneNumberConfirmed?: boolean;
    twoFactorEnabled?: boolean;
    lockoutEnd?: Date | undefined;
    lockoutEnabled?: boolean;
    accessFailedCount?: number;
}

export class IdentityUser extends IdentityUserOfString implements IIdentityUser {

    constructor(data?: IIdentityUser) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): IdentityUser {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityUser();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IIdentityUser extends IIdentityUserOfString {
}

export class ApplicationUser extends IdentityUser implements IApplicationUser {

    constructor(data?: IApplicationUser) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ApplicationUser {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationUser();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IApplicationUser extends IIdentityUser {
}

export class UserUpdateResponseDto implements IUserUpdateResponseDto {
    isSuccessful?: boolean;
    message?: string | undefined;
    updatedUser?: ApplicationUser | undefined;

    constructor(data?: IUserUpdateResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccessful = _data["isSuccessful"];
            this.message = _data["message"];
            this.updatedUser = _data["updatedUser"] ? ApplicationUser.fromJS(_data["updatedUser"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserUpdateResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserUpdateResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccessful"] = this.isSuccessful;
        data["message"] = this.message;
        data["updatedUser"] = this.updatedUser ? this.updatedUser.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUserUpdateResponseDto {
    isSuccessful?: boolean;
    message?: string | undefined;
    updatedUser?: ApplicationUser | undefined;
}

export class CreateUserDto implements ICreateUserDto {
    userName?: string | undefined;
    email?: string | undefined;
    password?: string | undefined;
    roles?: string[] | undefined;

    constructor(data?: ICreateUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.email = _data["email"];
            this.password = _data["password"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["email"] = this.email;
        data["password"] = this.password;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        return data;
    }
}

export interface ICreateUserDto {
    userName?: string | undefined;
    email?: string | undefined;
    password?: string | undefined;
    roles?: string[] | undefined;
}

export class UpdateUserDto implements IUpdateUserDto {
    userName?: string;
    email?: string;
    roles?: string[];

    constructor(data?: IUpdateUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.email = _data["email"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["email"] = this.email;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        return data;
    }
}

export interface IUpdateUserDto {
    userName?: string;
    email?: string;
    roles?: string[];
}

export class CreateDealerDto implements ICreateDealerDto {
    name?: string | undefined;
    logoUrl?: string | undefined;
    price?: number | undefined;
    userName?: string | undefined;
    email?: string | undefined;
    password?: string | undefined;
    enforceBilling?: boolean;

    constructor(data?: ICreateDealerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.logoUrl = _data["logoUrl"];
            this.price = _data["price"];
            this.userName = _data["userName"];
            this.email = _data["email"];
            this.password = _data["password"];
            this.enforceBilling = _data["enforceBilling"];
        }
    }

    static fromJS(data: any): CreateDealerDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDealerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["logoUrl"] = this.logoUrl;
        data["price"] = this.price;
        data["userName"] = this.userName;
        data["email"] = this.email;
        data["password"] = this.password;
        data["enforceBilling"] = this.enforceBilling;
        return data;
    }
}

export interface ICreateDealerDto {
    name?: string | undefined;
    logoUrl?: string | undefined;
    price?: number | undefined;
    userName?: string | undefined;
    email?: string | undefined;
    password?: string | undefined;
    enforceBilling?: boolean;
}

export class DealerDto implements IDealerDto {
    id?: number;
    name?: string | undefined;
    logoUri?: string | undefined;
    price?: number | undefined;
    logoBlobName?: string | undefined;
    users?: UserDto[] | undefined;
    enforceBilling?: boolean;

    constructor(data?: IDealerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.logoUri = _data["logoUri"];
            this.price = _data["price"];
            this.logoBlobName = _data["logoBlobName"];
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(UserDto.fromJS(item));
            }
            this.enforceBilling = _data["enforceBilling"];
        }
    }

    static fromJS(data: any): DealerDto {
        data = typeof data === 'object' ? data : {};
        let result = new DealerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["logoUri"] = this.logoUri;
        data["price"] = this.price;
        data["logoBlobName"] = this.logoBlobName;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        data["enforceBilling"] = this.enforceBilling;
        return data;
    }
}

export interface IDealerDto {
    id?: number;
    name?: string | undefined;
    logoUri?: string | undefined;
    price?: number | undefined;
    logoBlobName?: string | undefined;
    users?: UserDto[] | undefined;
    enforceBilling?: boolean;
}

export class UserDto implements IUserDto {
    id?: string | undefined;
    value?: string | undefined;
    email?: string | undefined;
    label?: string | undefined;
    roles?: string[] | undefined;
    isAdmin?: boolean;
    dealerId?: number | undefined;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
            this.email = _data["email"];
            this.label = _data["label"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            this.isAdmin = _data["isAdmin"];
            this.dealerId = _data["dealerId"];
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        data["email"] = this.email;
        data["label"] = this.label;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["isAdmin"] = this.isAdmin;
        data["dealerId"] = this.dealerId;
        return data;
    }
}

export interface IUserDto {
    id?: string | undefined;
    value?: string | undefined;
    email?: string | undefined;
    label?: string | undefined;
    roles?: string[] | undefined;
    isAdmin?: boolean;
    dealerId?: number | undefined;
}

export class DealerLogoInfoDto implements IDealerLogoInfoDto {
    dealerId?: number;
    logoBlobName?: string | undefined;
    logoUri?: string | undefined;

    constructor(data?: IDealerLogoInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dealerId = _data["dealerId"];
            this.logoBlobName = _data["logoBlobName"];
            this.logoUri = _data["logoUri"];
        }
    }

    static fromJS(data: any): DealerLogoInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new DealerLogoInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dealerId"] = this.dealerId;
        data["logoBlobName"] = this.logoBlobName;
        data["logoUri"] = this.logoUri;
        return data;
    }
}

export interface IDealerLogoInfoDto {
    dealerId?: number;
    logoBlobName?: string | undefined;
    logoUri?: string | undefined;
}

export class AttachmentDto implements IAttachmentDto {
    url?: string | undefined;

    constructor(data?: IAttachmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): AttachmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttachmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        return data;
    }
}

export interface IAttachmentDto {
    url?: string | undefined;
}

export class CategoryDto implements ICategoryDto {
    id?: number;
    name?: string | undefined;
    sortOrder?: number;

    constructor(data?: ICategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): CategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface ICategoryDto {
    id?: number;
    name?: string | undefined;
    sortOrder?: number;
}

export class DealerLogoDto implements IDealerLogoDto {
    id?: number | undefined;
    logoUri?: string | undefined;
    name?: string | undefined;

    constructor(data?: IDealerLogoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.logoUri = _data["logoUri"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): DealerLogoDto {
        data = typeof data === 'object' ? data : {};
        let result = new DealerLogoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["logoUri"] = this.logoUri;
        data["name"] = this.name;
        return data;
    }
}

export interface IDealerLogoDto {
    id?: number | undefined;
    logoUri?: string | undefined;
    name?: string | undefined;
}

export class InspectionItemDto implements IInspectionItemDto {
    id?: number;
    categoryId?: number;
    name?: string | undefined;
    hasPhoto?: boolean;
    description?: string | undefined;
    sortOrder?: number;
    statusLabelGreen?: string | undefined;
    statusLabelYellow?: string | undefined;
    statusLabelRed?: string | undefined;

    constructor(data?: IInspectionItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.categoryId = _data["categoryId"];
            this.name = _data["name"];
            this.hasPhoto = _data["hasPhoto"];
            this.description = _data["description"];
            this.sortOrder = _data["sortOrder"];
            this.statusLabelGreen = _data["statusLabelGreen"];
            this.statusLabelYellow = _data["statusLabelYellow"];
            this.statusLabelRed = _data["statusLabelRed"];
        }
    }

    static fromJS(data: any): InspectionItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["categoryId"] = this.categoryId;
        data["name"] = this.name;
        data["hasPhoto"] = this.hasPhoto;
        data["description"] = this.description;
        data["sortOrder"] = this.sortOrder;
        data["statusLabelGreen"] = this.statusLabelGreen;
        data["statusLabelYellow"] = this.statusLabelYellow;
        data["statusLabelRed"] = this.statusLabelRed;
        return data;
    }
}

export interface IInspectionItemDto {
    id?: number;
    categoryId?: number;
    name?: string | undefined;
    hasPhoto?: boolean;
    description?: string | undefined;
    sortOrder?: number;
    statusLabelGreen?: string | undefined;
    statusLabelYellow?: string | undefined;
    statusLabelRed?: string | undefined;
}

export class CreateInspectionItemCommand implements ICreateInspectionItemCommand {
    categoryId?: number;
    name?: string | undefined;
    hasPhoto?: boolean;
    description?: string | undefined;

    constructor(data?: ICreateInspectionItemCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryId = _data["categoryId"];
            this.name = _data["name"];
            this.hasPhoto = _data["hasPhoto"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CreateInspectionItemCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInspectionItemCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryId"] = this.categoryId;
        data["name"] = this.name;
        data["hasPhoto"] = this.hasPhoto;
        data["description"] = this.description;
        return data;
    }
}

export interface ICreateInspectionItemCommand {
    categoryId?: number;
    name?: string | undefined;
    hasPhoto?: boolean;
    description?: string | undefined;
}

export class UpdateInspectionItemCommand implements IUpdateInspectionItemCommand {
    id?: number;
    categoryId?: number;
    name?: string | undefined;
    hasPhoto?: boolean;
    description?: string | undefined;
    sortOrder?: number;
    statusLabelGreen?: string | undefined;
    statusLabelYellow?: string | undefined;
    statusLabelRed?: string | undefined;

    constructor(data?: IUpdateInspectionItemCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.categoryId = _data["categoryId"];
            this.name = _data["name"];
            this.hasPhoto = _data["hasPhoto"];
            this.description = _data["description"];
            this.sortOrder = _data["sortOrder"];
            this.statusLabelGreen = _data["statusLabelGreen"];
            this.statusLabelYellow = _data["statusLabelYellow"];
            this.statusLabelRed = _data["statusLabelRed"];
        }
    }

    static fromJS(data: any): UpdateInspectionItemCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInspectionItemCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["categoryId"] = this.categoryId;
        data["name"] = this.name;
        data["hasPhoto"] = this.hasPhoto;
        data["description"] = this.description;
        data["sortOrder"] = this.sortOrder;
        data["statusLabelGreen"] = this.statusLabelGreen;
        data["statusLabelYellow"] = this.statusLabelYellow;
        data["statusLabelRed"] = this.statusLabelRed;
        return data;
    }
}

export interface IUpdateInspectionItemCommand {
    id?: number;
    categoryId?: number;
    name?: string | undefined;
    hasPhoto?: boolean;
    description?: string | undefined;
    sortOrder?: number;
    statusLabelGreen?: string | undefined;
    statusLabelYellow?: string | undefined;
    statusLabelRed?: string | undefined;
}

export class InspectionDto implements IInspectionDto {
    id?: number;
    dealerId?: number;
    vehicleId?: number;
    vehicleLabel?: string | undefined;
    vehicleYear?: string | undefined;
    vehicleMake?: string | undefined;
    vehicleModel?: string | undefined;
    vehicleVin?: string | undefined;
    vehicleStockNumber?: string | undefined;
    status?: number;
    historyUri?: string | undefined;
    inspectionDate?: Date;
    inspectorName?: string | undefined;
    notes?: string | undefined;
    created?: Date;
    lastModified?: Date | undefined;
    vehicleHistoryReportUrl?: string | undefined;
    vehicleHistoryReportUploaded?: Date | undefined;
    vehicleHistoryReportUploadedBy?: string | undefined;
    vehicleServiceRecordUrl?: string | undefined;
    vehicleServiceRecordBlobName?: string | undefined;
    vehicleServiceRecordUploaded?: Date | undefined;
    vehicleServiceRecordUploadedBy?: string | undefined;
    dealerWebsiteLink?: string | undefined;
    inspectionItemRecords?: InspectionItemRecordDto[] | undefined;
    scanCount?: number | undefined;

    constructor(data?: IInspectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dealerId = _data["dealerId"];
            this.vehicleId = _data["vehicleId"];
            this.vehicleLabel = _data["vehicleLabel"];
            this.vehicleYear = _data["vehicleYear"];
            this.vehicleMake = _data["vehicleMake"];
            this.vehicleModel = _data["vehicleModel"];
            this.vehicleVin = _data["vehicleVin"];
            this.vehicleStockNumber = _data["vehicleStockNumber"];
            this.status = _data["status"];
            this.historyUri = _data["historyUri"];
            this.inspectionDate = _data["inspectionDate"] ? new Date(_data["inspectionDate"].toString()) : <any>undefined;
            this.inspectorName = _data["inspectorName"];
            this.notes = _data["notes"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.vehicleHistoryReportUrl = _data["vehicleHistoryReportUrl"];
            this.vehicleHistoryReportUploaded = _data["vehicleHistoryReportUploaded"] ? new Date(_data["vehicleHistoryReportUploaded"].toString()) : <any>undefined;
            this.vehicleHistoryReportUploadedBy = _data["vehicleHistoryReportUploadedBy"];
            this.vehicleServiceRecordUrl = _data["vehicleServiceRecordUrl"];
            this.vehicleServiceRecordBlobName = _data["vehicleServiceRecordBlobName"];
            this.vehicleServiceRecordUploaded = _data["vehicleServiceRecordUploaded"] ? new Date(_data["vehicleServiceRecordUploaded"].toString()) : <any>undefined;
            this.vehicleServiceRecordUploadedBy = _data["vehicleServiceRecordUploadedBy"];
            this.dealerWebsiteLink = _data["dealerWebsiteLink"];
            if (Array.isArray(_data["inspectionItemRecords"])) {
                this.inspectionItemRecords = [] as any;
                for (let item of _data["inspectionItemRecords"])
                    this.inspectionItemRecords!.push(InspectionItemRecordDto.fromJS(item));
            }
            this.scanCount = _data["scanCount"];
        }
    }

    static fromJS(data: any): InspectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dealerId"] = this.dealerId;
        data["vehicleId"] = this.vehicleId;
        data["vehicleLabel"] = this.vehicleLabel;
        data["vehicleYear"] = this.vehicleYear;
        data["vehicleMake"] = this.vehicleMake;
        data["vehicleModel"] = this.vehicleModel;
        data["vehicleVin"] = this.vehicleVin;
        data["vehicleStockNumber"] = this.vehicleStockNumber;
        data["status"] = this.status;
        data["historyUri"] = this.historyUri;
        data["inspectionDate"] = this.inspectionDate ? this.inspectionDate.toISOString() : <any>undefined;
        data["inspectorName"] = this.inspectorName;
        data["notes"] = this.notes;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["vehicleHistoryReportUrl"] = this.vehicleHistoryReportUrl;
        data["vehicleHistoryReportUploaded"] = this.vehicleHistoryReportUploaded ? this.vehicleHistoryReportUploaded.toISOString() : <any>undefined;
        data["vehicleHistoryReportUploadedBy"] = this.vehicleHistoryReportUploadedBy;
        data["vehicleServiceRecordUrl"] = this.vehicleServiceRecordUrl;
        data["vehicleServiceRecordBlobName"] = this.vehicleServiceRecordBlobName;
        data["vehicleServiceRecordUploaded"] = this.vehicleServiceRecordUploaded ? this.vehicleServiceRecordUploaded.toISOString() : <any>undefined;
        data["vehicleServiceRecordUploadedBy"] = this.vehicleServiceRecordUploadedBy;
        data["dealerWebsiteLink"] = this.dealerWebsiteLink;
        if (Array.isArray(this.inspectionItemRecords)) {
            data["inspectionItemRecords"] = [];
            for (let item of this.inspectionItemRecords)
                data["inspectionItemRecords"].push(item.toJSON());
        }
        data["scanCount"] = this.scanCount;
        return data;
    }
}

export interface IInspectionDto {
    id?: number;
    dealerId?: number;
    vehicleId?: number;
    vehicleLabel?: string | undefined;
    vehicleYear?: string | undefined;
    vehicleMake?: string | undefined;
    vehicleModel?: string | undefined;
    vehicleVin?: string | undefined;
    vehicleStockNumber?: string | undefined;
    status?: number;
    historyUri?: string | undefined;
    inspectionDate?: Date;
    inspectorName?: string | undefined;
    notes?: string | undefined;
    created?: Date;
    lastModified?: Date | undefined;
    vehicleHistoryReportUrl?: string | undefined;
    vehicleHistoryReportUploaded?: Date | undefined;
    vehicleHistoryReportUploadedBy?: string | undefined;
    vehicleServiceRecordUrl?: string | undefined;
    vehicleServiceRecordBlobName?: string | undefined;
    vehicleServiceRecordUploaded?: Date | undefined;
    vehicleServiceRecordUploadedBy?: string | undefined;
    dealerWebsiteLink?: string | undefined;
    inspectionItemRecords?: InspectionItemRecordDto[] | undefined;
    scanCount?: number | undefined;
}

export class InspectionItemRecordDto implements IInspectionItemRecordDto {
    id?: number;
    inspectionId?: number;
    inspectionItemId?: number;
    status?: number;
    note?: string | undefined;
    recommendation?: string | undefined;
    photoUri?: string | undefined;
    created?: Date;
    lastModified?: Date | undefined;

    constructor(data?: IInspectionItemRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.inspectionId = _data["inspectionId"];
            this.inspectionItemId = _data["inspectionItemId"];
            this.status = _data["status"];
            this.note = _data["note"];
            this.recommendation = _data["recommendation"];
            this.photoUri = _data["photoUri"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): InspectionItemRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionItemRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["inspectionId"] = this.inspectionId;
        data["inspectionItemId"] = this.inspectionItemId;
        data["status"] = this.status;
        data["note"] = this.note;
        data["recommendation"] = this.recommendation;
        data["photoUri"] = this.photoUri;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        return data;
    }
}

export interface IInspectionItemRecordDto {
    id?: number;
    inspectionId?: number;
    inspectionItemId?: number;
    status?: number;
    note?: string | undefined;
    recommendation?: string | undefined;
    photoUri?: string | undefined;
    created?: Date;
    lastModified?: Date | undefined;
}

export class PhotoResponseDto implements IPhotoResponseDto {
    id?: number;
    inspectionId?: number;
    inspectionItemId?: number;
    url?: string | undefined;
    thumbnailUrl?: string | undefined;
    sortOrder?: number | undefined;
    created?: Date;
    kind?: InspectionMediaKind;
    contentType?: string | undefined;
    fileSizeBytes?: number | undefined;
    durationMs?: number | undefined;

    constructor(data?: IPhotoResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.inspectionId = _data["inspectionId"];
            this.inspectionItemId = _data["inspectionItemId"];
            this.url = _data["url"];
            this.thumbnailUrl = _data["thumbnailUrl"];
            this.sortOrder = _data["sortOrder"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.kind = _data["kind"];
            this.contentType = _data["contentType"];
            this.fileSizeBytes = _data["fileSizeBytes"];
            this.durationMs = _data["durationMs"];
        }
    }

    static fromJS(data: any): PhotoResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new PhotoResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["inspectionId"] = this.inspectionId;
        data["inspectionItemId"] = this.inspectionItemId;
        data["url"] = this.url;
        data["thumbnailUrl"] = this.thumbnailUrl;
        data["sortOrder"] = this.sortOrder;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["kind"] = this.kind;
        data["contentType"] = this.contentType;
        data["fileSizeBytes"] = this.fileSizeBytes;
        data["durationMs"] = this.durationMs;
        return data;
    }
}

export interface IPhotoResponseDto {
    id?: number;
    inspectionId?: number;
    inspectionItemId?: number;
    url?: string | undefined;
    thumbnailUrl?: string | undefined;
    sortOrder?: number | undefined;
    created?: Date;
    kind?: InspectionMediaKind;
    contentType?: string | undefined;
    fileSizeBytes?: number | undefined;
    durationMs?: number | undefined;
}

export enum InspectionMediaKind {
    Photo = 0,
    Video = 1,
}

export class PaginatedListOfInspectionDto implements IPaginatedListOfInspectionDto {
    items?: InspectionDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfInspectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(InspectionDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfInspectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfInspectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfInspectionDto {
    items?: InspectionDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class CreateInspectionCommand implements ICreateInspectionCommand {
    dealerId?: number;
    vehicleId?: number;
    status?: number;
    inspectionDate?: Date;
    inspectorName?: string | undefined;
    notes?: string | undefined;
    dealerWebsiteLink?: string | undefined;
    inspectionItemRecords?: InspectionItemRecordDto[] | undefined;

    constructor(data?: ICreateInspectionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dealerId = _data["dealerId"];
            this.vehicleId = _data["vehicleId"];
            this.status = _data["status"];
            this.inspectionDate = _data["inspectionDate"] ? new Date(_data["inspectionDate"].toString()) : <any>undefined;
            this.inspectorName = _data["inspectorName"];
            this.notes = _data["notes"];
            this.dealerWebsiteLink = _data["dealerWebsiteLink"];
            if (Array.isArray(_data["inspectionItemRecords"])) {
                this.inspectionItemRecords = [] as any;
                for (let item of _data["inspectionItemRecords"])
                    this.inspectionItemRecords!.push(InspectionItemRecordDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateInspectionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInspectionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dealerId"] = this.dealerId;
        data["vehicleId"] = this.vehicleId;
        data["status"] = this.status;
        data["inspectionDate"] = this.inspectionDate ? this.inspectionDate.toISOString() : <any>undefined;
        data["inspectorName"] = this.inspectorName;
        data["notes"] = this.notes;
        data["dealerWebsiteLink"] = this.dealerWebsiteLink;
        if (Array.isArray(this.inspectionItemRecords)) {
            data["inspectionItemRecords"] = [];
            for (let item of this.inspectionItemRecords)
                data["inspectionItemRecords"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateInspectionCommand {
    dealerId?: number;
    vehicleId?: number;
    status?: number;
    inspectionDate?: Date;
    inspectorName?: string | undefined;
    notes?: string | undefined;
    dealerWebsiteLink?: string | undefined;
    inspectionItemRecords?: InspectionItemRecordDto[] | undefined;
}

export class UpdateInspectionCommand implements IUpdateInspectionCommand {
    id?: number;
    dealerId?: number;
    vehicleId?: number;
    status?: number;
    inspectionDate?: Date;
    inspectorName?: string | undefined;
    notes?: string | undefined;
    dealerWebsiteLink?: string | undefined;
    inspectionRecords?: InspectionItemRecordDto[] | undefined;

    constructor(data?: IUpdateInspectionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dealerId = _data["dealerId"];
            this.vehicleId = _data["vehicleId"];
            this.status = _data["status"];
            this.inspectionDate = _data["inspectionDate"] ? new Date(_data["inspectionDate"].toString()) : <any>undefined;
            this.inspectorName = _data["inspectorName"];
            this.notes = _data["notes"];
            this.dealerWebsiteLink = _data["dealerWebsiteLink"];
            if (Array.isArray(_data["inspectionRecords"])) {
                this.inspectionRecords = [] as any;
                for (let item of _data["inspectionRecords"])
                    this.inspectionRecords!.push(InspectionItemRecordDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateInspectionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInspectionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dealerId"] = this.dealerId;
        data["vehicleId"] = this.vehicleId;
        data["status"] = this.status;
        data["inspectionDate"] = this.inspectionDate ? this.inspectionDate.toISOString() : <any>undefined;
        data["inspectorName"] = this.inspectorName;
        data["notes"] = this.notes;
        data["dealerWebsiteLink"] = this.dealerWebsiteLink;
        if (Array.isArray(this.inspectionRecords)) {
            data["inspectionRecords"] = [];
            for (let item of this.inspectionRecords)
                data["inspectionRecords"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateInspectionCommand {
    id?: number;
    dealerId?: number;
    vehicleId?: number;
    status?: number;
    inspectionDate?: Date;
    inspectorName?: string | undefined;
    notes?: string | undefined;
    dealerWebsiteLink?: string | undefined;
    inspectionRecords?: InspectionItemRecordDto[] | undefined;
}

export class LeadDto implements ILeadDto {
    id?: number | undefined;
    dealerId?: number;
    vehicleId?: number;
    vehicleLabel?: string | undefined;
    inspectionId?: number;
    name?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    message?: string | undefined;
    isHelpful?: boolean | undefined;
    contactMe?: boolean | undefined;
    internalNotes?: string | undefined;
    created?: Date;
    isArchived?: boolean;

    constructor(data?: ILeadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dealerId = _data["dealerId"];
            this.vehicleId = _data["vehicleId"];
            this.vehicleLabel = _data["vehicleLabel"];
            this.inspectionId = _data["inspectionId"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.message = _data["message"];
            this.isHelpful = _data["isHelpful"];
            this.contactMe = _data["contactMe"];
            this.internalNotes = _data["internalNotes"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.isArchived = _data["isArchived"];
        }
    }

    static fromJS(data: any): LeadDto {
        data = typeof data === 'object' ? data : {};
        let result = new LeadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dealerId"] = this.dealerId;
        data["vehicleId"] = this.vehicleId;
        data["vehicleLabel"] = this.vehicleLabel;
        data["inspectionId"] = this.inspectionId;
        data["name"] = this.name;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["message"] = this.message;
        data["isHelpful"] = this.isHelpful;
        data["contactMe"] = this.contactMe;
        data["internalNotes"] = this.internalNotes;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["isArchived"] = this.isArchived;
        return data;
    }
}

export interface ILeadDto {
    id?: number | undefined;
    dealerId?: number;
    vehicleId?: number;
    vehicleLabel?: string | undefined;
    inspectionId?: number;
    name?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    message?: string | undefined;
    isHelpful?: boolean | undefined;
    contactMe?: boolean | undefined;
    internalNotes?: string | undefined;
    created?: Date;
    isArchived?: boolean;
}

export class GlobalSearchDto implements IGlobalSearchDto {
    vehicles?: SearchItem[];

    constructor(data?: IGlobalSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["vehicles"])) {
                this.vehicles = [] as any;
                for (let item of _data["vehicles"])
                    this.vehicles!.push(SearchItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GlobalSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new GlobalSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.vehicles)) {
            data["vehicles"] = [];
            for (let item of this.vehicles)
                data["vehicles"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGlobalSearchDto {
    vehicles?: SearchItem[];
}

export class SearchItem implements ISearchItem {
    path?: string;
    type?: string;
    label?: string;

    constructor(data?: ISearchItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.path = _data["path"];
            this.type = _data["type"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): SearchItem {
        data = typeof data === 'object' ? data : {};
        let result = new SearchItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["path"] = this.path;
        data["type"] = this.type;
        data["label"] = this.label;
        return data;
    }
}

export interface ISearchItem {
    path?: string;
    type?: string;
    label?: string;
}

export class VehicleDto implements IVehicleDto {
    id?: number;
    dealerId?: number;
    vin?: string | undefined;
    makeId?: number | undefined;
    modelId?: number | undefined;
    makeName?: string | undefined;
    modelName?: string | undefined;
    year?: string | undefined;
    status?: number;
    stockNumber?: string | undefined;
    trim?: string | undefined;
    mileage?: number | undefined;
    color?: string | undefined;
    photoUri?: string | undefined;
    created?: Date;
    createdBy?: string | undefined;
    lastModified?: Date;
    lastModifiedBy?: string | undefined;

    constructor(data?: IVehicleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dealerId = _data["dealerId"];
            this.vin = _data["vin"];
            this.makeId = _data["makeId"];
            this.modelId = _data["modelId"];
            this.makeName = _data["makeName"];
            this.modelName = _data["modelName"];
            this.year = _data["year"];
            this.status = _data["status"];
            this.stockNumber = _data["stockNumber"];
            this.trim = _data["trim"];
            this.mileage = _data["mileage"];
            this.color = _data["color"];
            this.photoUri = _data["photoUri"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
        }
    }

    static fromJS(data: any): VehicleDto {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dealerId"] = this.dealerId;
        data["vin"] = this.vin;
        data["makeId"] = this.makeId;
        data["modelId"] = this.modelId;
        data["makeName"] = this.makeName;
        data["modelName"] = this.modelName;
        data["year"] = this.year;
        data["status"] = this.status;
        data["stockNumber"] = this.stockNumber;
        data["trim"] = this.trim;
        data["mileage"] = this.mileage;
        data["color"] = this.color;
        data["photoUri"] = this.photoUri;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        return data;
    }
}

export interface IVehicleDto {
    id?: number;
    dealerId?: number;
    vin?: string | undefined;
    makeId?: number | undefined;
    modelId?: number | undefined;
    makeName?: string | undefined;
    modelName?: string | undefined;
    year?: string | undefined;
    status?: number;
    stockNumber?: string | undefined;
    trim?: string | undefined;
    mileage?: number | undefined;
    color?: string | undefined;
    photoUri?: string | undefined;
    created?: Date;
    createdBy?: string | undefined;
    lastModified?: Date;
    lastModifiedBy?: string | undefined;
}

export class VinSummaryDto implements IVinSummaryDto {
    vin?: string | undefined;
    makeId?: number | undefined;
    modelId?: number | undefined;
    makeVpicId?: number | undefined;
    modelVpicId?: number | undefined;
    year?: string | undefined;
    trim?: string | undefined;
    make?: string | undefined;
    model?: string | undefined;

    constructor(data?: IVinSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vin = _data["vin"];
            this.makeId = _data["makeId"];
            this.modelId = _data["modelId"];
            this.makeVpicId = _data["makeVpicId"];
            this.modelVpicId = _data["modelVpicId"];
            this.year = _data["year"];
            this.trim = _data["trim"];
            this.make = _data["make"];
            this.model = _data["model"];
        }
    }

    static fromJS(data: any): VinSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new VinSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vin"] = this.vin;
        data["makeId"] = this.makeId;
        data["modelId"] = this.modelId;
        data["makeVpicId"] = this.makeVpicId;
        data["modelVpicId"] = this.modelVpicId;
        data["year"] = this.year;
        data["trim"] = this.trim;
        data["make"] = this.make;
        data["model"] = this.model;
        return data;
    }
}

export interface IVinSummaryDto {
    vin?: string | undefined;
    makeId?: number | undefined;
    modelId?: number | undefined;
    makeVpicId?: number | undefined;
    modelVpicId?: number | undefined;
    year?: string | undefined;
    trim?: string | undefined;
    make?: string | undefined;
    model?: string | undefined;
}

export class PaginatedListOfVehicleDto implements IPaginatedListOfVehicleDto {
    items?: VehicleDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfVehicleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(VehicleDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfVehicleDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfVehicleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfVehicleDto {
    items?: VehicleDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class IdLabelDto implements IIdLabelDto {
    id?: number | undefined;
    label?: string | undefined;

    constructor(data?: IIdLabelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): IdLabelDto {
        data = typeof data === 'object' ? data : {};
        let result = new IdLabelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["label"] = this.label;
        return data;
    }
}

export interface IIdLabelDto {
    id?: number | undefined;
    label?: string | undefined;
}

export class CreateVehicleCommand implements ICreateVehicleCommand {
    dealerId?: number;
    vin?: string | undefined;
    makeId?: number | undefined;
    modelId?: number | undefined;
    year?: string | undefined;
    status?: number;
    stockNumber?: string | undefined;
    trim?: string | undefined;
    mileage?: number | undefined;
    color?: string | undefined;
    photoUri?: string | undefined;

    constructor(data?: ICreateVehicleCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dealerId = _data["dealerId"];
            this.vin = _data["vin"];
            this.makeId = _data["makeId"];
            this.modelId = _data["modelId"];
            this.year = _data["year"];
            this.status = _data["status"];
            this.stockNumber = _data["stockNumber"];
            this.trim = _data["trim"];
            this.mileage = _data["mileage"];
            this.color = _data["color"];
            this.photoUri = _data["photoUri"];
        }
    }

    static fromJS(data: any): CreateVehicleCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateVehicleCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dealerId"] = this.dealerId;
        data["vin"] = this.vin;
        data["makeId"] = this.makeId;
        data["modelId"] = this.modelId;
        data["year"] = this.year;
        data["status"] = this.status;
        data["stockNumber"] = this.stockNumber;
        data["trim"] = this.trim;
        data["mileage"] = this.mileage;
        data["color"] = this.color;
        data["photoUri"] = this.photoUri;
        return data;
    }
}

export interface ICreateVehicleCommand {
    dealerId?: number;
    vin?: string | undefined;
    makeId?: number | undefined;
    modelId?: number | undefined;
    year?: string | undefined;
    status?: number;
    stockNumber?: string | undefined;
    trim?: string | undefined;
    mileage?: number | undefined;
    color?: string | undefined;
    photoUri?: string | undefined;
}

export class UpdateVehicleCommand implements IUpdateVehicleCommand {
    id?: number;
    dealerId?: number;
    vin?: string | undefined;
    makeId?: number | undefined;
    modelId?: number | undefined;
    year?: string | undefined;
    status?: number;
    stockNumber?: string | undefined;
    trim?: string | undefined;
    mileage?: number | undefined;
    color?: string | undefined;
    photoUri?: string | undefined;

    constructor(data?: IUpdateVehicleCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dealerId = _data["dealerId"];
            this.vin = _data["vin"];
            this.makeId = _data["makeId"];
            this.modelId = _data["modelId"];
            this.year = _data["year"];
            this.status = _data["status"];
            this.stockNumber = _data["stockNumber"];
            this.trim = _data["trim"];
            this.mileage = _data["mileage"];
            this.color = _data["color"];
            this.photoUri = _data["photoUri"];
        }
    }

    static fromJS(data: any): UpdateVehicleCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateVehicleCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dealerId"] = this.dealerId;
        data["vin"] = this.vin;
        data["makeId"] = this.makeId;
        data["modelId"] = this.modelId;
        data["year"] = this.year;
        data["status"] = this.status;
        data["stockNumber"] = this.stockNumber;
        data["trim"] = this.trim;
        data["mileage"] = this.mileage;
        data["color"] = this.color;
        data["photoUri"] = this.photoUri;
        return data;
    }
}

export interface IUpdateVehicleCommand {
    id?: number;
    dealerId?: number;
    vin?: string | undefined;
    makeId?: number | undefined;
    modelId?: number | undefined;
    year?: string | undefined;
    status?: number;
    stockNumber?: string | undefined;
    trim?: string | undefined;
    mileage?: number | undefined;
    color?: string | undefined;
    photoUri?: string | undefined;
}

export class StartCheckoutDto implements IStartCheckoutDto {
    dealerId?: number | undefined;

    constructor(data?: IStartCheckoutDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dealerId = _data["dealerId"];
        }
    }

    static fromJS(data: any): StartCheckoutDto {
        data = typeof data === 'object' ? data : {};
        let result = new StartCheckoutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dealerId"] = this.dealerId;
        return data;
    }
}

export interface IStartCheckoutDto {
    dealerId?: number | undefined;
}

export class PortalRequest implements IPortalRequest {
    dealerId?: number | undefined;

    constructor(data?: IPortalRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dealerId = _data["dealerId"];
        }
    }

    static fromJS(data: any): PortalRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PortalRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dealerId"] = this.dealerId;
        return data;
    }
}

export interface IPortalRequest {
    dealerId?: number | undefined;
}

export class BillingStatusResponse implements IBillingStatusResponse {
    status?: string;
    amountCents?: number;
    currency?: string;
    currentPeriodEnd?: Date | undefined;
    trialEnd?: Date | undefined;
    stripeCustomerId?: string | undefined;
    stripeSubscriptionId?: string | undefined;

    constructor(data?: IBillingStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.amountCents = _data["amountCents"];
            this.currency = _data["currency"];
            this.currentPeriodEnd = _data["currentPeriodEnd"] ? new Date(_data["currentPeriodEnd"].toString()) : <any>undefined;
            this.trialEnd = _data["trialEnd"] ? new Date(_data["trialEnd"].toString()) : <any>undefined;
            this.stripeCustomerId = _data["stripeCustomerId"];
            this.stripeSubscriptionId = _data["stripeSubscriptionId"];
        }
    }

    static fromJS(data: any): BillingStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BillingStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["amountCents"] = this.amountCents;
        data["currency"] = this.currency;
        data["currentPeriodEnd"] = this.currentPeriodEnd ? this.currentPeriodEnd.toISOString() : <any>undefined;
        data["trialEnd"] = this.trialEnd ? this.trialEnd.toISOString() : <any>undefined;
        data["stripeCustomerId"] = this.stripeCustomerId;
        data["stripeSubscriptionId"] = this.stripeSubscriptionId;
        return data;
    }
}

export interface IBillingStatusResponse {
    status?: string;
    amountCents?: number;
    currency?: string;
    currentPeriodEnd?: Date | undefined;
    trialEnd?: Date | undefined;
    stripeCustomerId?: string | undefined;
    stripeSubscriptionId?: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}